/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import DateComponent from 'app/components/commons/DateComponent';
import ChallengeStatusPill from 'app/components/challenge/ChallengeStatusPill';
import Countdown from 'app/components/commons/Countdown';
import { SCHEDULED, OPEN } from 'app/constants/challengeStatusTypes';

type Props = {
  startTime?: number | string,
  statusId: number,
  statusLabel: string
};

const Subtitle = styled.div(({ theme }) => ({
  fontSize: theme.fontSize.small,
  textAlign: 'center',
  [theme.mediaQuery.desktopLargeOnly]: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'left'
  }
}));

const StartTime = styled.div(({ theme }) => ({
  color: theme.color.basis5,
  marginBottom: '0.25em',
  [theme.mediaQuery.desktopLargeOnly]: {
    marginBottom: 0,
    paddingRight: '1em'
  }
}));

const Status = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center'
});

const CountdownWrapper = styled.div({
  paddingRight: '1em'
});

const defaultProps = {
  startTime: undefined
};

function ChallengeTimeStatusInfo({ startTime, statusId, statusLabel }: Props) {
  return (
    <Subtitle>
      <StartTime>
        <DateComponent date={startTime} format="dddd, MMM Do YYYY - h:mm a" />
      </StartTime>
      <Status>
        {(statusId === SCHEDULED || statusId === OPEN) && (
          <CountdownWrapper>
            <Countdown starting={startTime} format="dd:hh:mm:ss" />
          </CountdownWrapper>
        )}
        <ChallengeStatusPill statusId={statusId}>{statusLabel}</ChallengeStatusPill>
      </Status>
    </Subtitle>
  );
}

ChallengeTimeStatusInfo.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    startTime: state.challenge.startTime,
    statusId: state.challenge.statusId,
    statusLabel: state.challenge.statusLabel
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {
    startTime: ownProps.startTime || stateProps.startTime,
    statusId: ownProps.statusId || stateProps.statusId,
    statusLabel: ownProps.statusLabel || stateProps.statusLabel
  };
}

export default connect(
  mapStateToProps,
  {},
  mergeProps
)(ChallengeTimeStatusInfo);
